import { loadChunk } from '../../../common/js/chunks.js';

/**
 * The library of the lightbox (PhotoSwipe) is a chunk of its own, frontend-photoswipe
 * (frontend-scripts.md, "The lightbox"): about 60 KB which a page without a thumbnail of the
 * lightbox never needs. The wrapper (PhotoSwipeGallery.js) stays in the bundle and asks here.
 */

/** @type {?Function} the class of PhotoSwipe, once its chunk is in */
let library = null;

/** @type {?Promise<Function>} */
let loading = null;

/**
 * @return {?Function} the class of PhotoSwipe, or null while its chunk is not in
 */
export function photoSwipeLibrary() {
    return library;
}

/**
 * Loads the chunk once; a chunk which did not load is asked for again by the next call.
 *
 * @return {Promise<Function>} the class of PhotoSwipe
 */
export function loadPhotoSwipe() {
    if (loading === null) {
        loading = loadChunk(() => import(/* webpackChunkName: "frontend-photoswipe" */ 'photoswipe'))
            .then((module) => {
                library = module.default;
                return library;
            })
            .catch((error) => {
                loading = null;
                throw error;
            });
    }
    return loading;
}

/**
 * Fetches the chunk while the browser idles after the load of the page, when the page holds a
 * thumbnail of the lightbox then - so that the first tap opens the lightbox at once and the
 * chunk takes nothing from the images of the page.
 *
 * @param {Document} [doc]
 * @param {Window} [win]
 */
export function preloadPhotoSwipeWhenIdle(doc = document, win = window) {
    const whenIdle = (callback) => (typeof win.requestIdleCallback === 'function'
        ? win.requestIdleCallback(callback, { timeout: 2000 })
        : win.setTimeout(callback, 200));
    const start = () => whenIdle(() => {
        if (doc.querySelector('a[data-eg-lightbox]')) {
            // a chunk which did not load is asked for again by the first tap
            loadPhotoSwipe().catch(() => {});
        }
    });

    if (doc.readyState === 'complete') {
        start();
    } else {
        win.addEventListener('load', start, { once: true });
    }
}
